/*
 * @Author: van
 * @Date: 2021-08-19 09:19:10
 * @LastEditors: van
 * @LastEditTime: 2021-09-29 12:34:21
 */
import * as types from '../types';
import {
    cmofferApi
} from '../../http/cmofferApi';
import that from '../../main';
import {
    Message
} from 'element-ui';

const state = {
    userInfo: {},
    menuList: [],

    uploadUrl: '',
    isChange: false,
    cartNum: '',
    addedCartNum: '',
    roleId: ''
};

const mutations = {
    [types.LOG_GETUSERINFO](state, status) {
        state.userInfo = Object.assign({}, status);
    },
    [types.INDEX_GETMENULIST](state, status) {
        state.menuList = [...status];
    },
    SETCARTNUM(state, val) {
        state.cartNum = +val;
        sessionStorage.setItem("CARTNUM", +val);
    },
    SETADDEDCARTNUM(state, val) {
        state.addedCartNum = +val;
        sessionStorage.setItem("ADDEDCARTNUM", +val);
    },
};

const getters = {
    // userInfo: state => state.userInfo,
    // roles: state => state.userInfo.user_type
};

const actions = {
    /**
     * 获取用户信息
     */
    getUserInfo({
        commit,
        dispatch,
        rootState
    }) {
        dispatch('getMenuListByRoles');

        // let user_id = localStorage.getItem('user_id');
        // erpApi.user({}, 'get', user_id).then(res => {
        //     if (res) {
        //         localStorage.setItem('userInfo', JSON.stringify(res.data));
        //         dispatch('getMenuListByRoles');
        //         commit(types.LOG_GETUSERINFO, res.data);
        //     }
        // });
    },
    /**
     * 获取菜单列表
     */
    async getMenuListByRoles({
        commit,
        state
    }) {
        // 旧
        // let res = await cmofferApi.authority({}, 'get')
        // 新
        let res = await cmofferApi.newAuthority({}, 'get')
        if (res) {
            const menu_list = res.data;
            if (menu_list instanceof Array && menu_list.length > 0) {
                localStorage.setItem('menu_list', JSON.stringify(menu_list));
                let activeTab = localStorage.getItem('activeTab');

                let path = '';
                if (activeTab) {
                    activeTab = `/${activeTab}`;
                    done:
                        for (let i = 0; i < menu_list.length; i++) {
                            const menu = menu_list[i];
                            if (menu.url && menu.url === activeTab) {
                                path = menu.url;
                                break;
                            }

                            const child = menu.child;
                            if (child && child instanceof Array) {
                                for (let j = 0; j < child.length; j++) {
                                    const subMenu = child[j];
                                    if (subMenu.url && subMenu.url === activeTab) {
                                        path = subMenu.url;
                                        break done;
                                    }

                                    const subChild = subMenu.child;
                                    if (subChild) {
                                        for (let k = 0; k < subChild.length; k++) {
                                            const subSonMenu = subChild[k];
                                            if (subSonMenu.url && subSonMenu.url === activeTab) {
                                                path = subSonMenu.url;
                                                break done;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                    if (path === '') {
                        localStorage.removeItem('activeTab');
                    }

                }

                if (path === '' && menu_list.length > 0) {
                    if (menu_list[0].child) {
                        if (menu_list[0].child[0].child) {
                            path = menu_list[0].child[0].child[0].url;
                        } else {
                            path = menu_list[0].child[0].url;
                        }
                    } else {
                        path = menu_list[0].url;
                    }
                }
                commit(types.INDEX_GETMENULIST, res.data);
                commit("SETCARTNUM", res.ext.cart_goods_num);

                if (state.isChange) {
                    that.$router.push(path);
                }
            }

            return menu_list;
        }
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};